import React, { useContext, useEffect, useRef, useState } from 'react'
import axios from 'axios'
import { baseUrl, path } from '../../constants'
import { Oval } from 'react-loader-spinner'
import { appContext } from '../../Context/appProvider'
import { Controller, useForm } from 'react-hook-form';
import Select from 'react-select';

const levelOptions = [
    { value: 'begginer', label: 'Begginer' },
    { value: 'intermidiate', label: 'Intermidiate' }
];

const languageOptions = [
    { value: 'English', label: 'English' },
    { value: 'Amharic', label: 'Amharic' }
];

export default function AddCourse() {
     const [uploading, setUploading] = useState(false)
     const [sources, setSources] = useState()
     const [files, setFiles] = useState([])
     const [categories, setCategories] = useState([])
     const [instructors, setInstructors] = useState([])
     const [selectedCategory, setSelectedCategory] = useState(null)

     const fileRef = useRef()
     const {setNotification} = useContext(appContext)
     const { register, handleSubmit, setValue, watch, control, formState: { errors, isSubmitting, isDirty, isValid } } = useForm();
     const categoryValue = watch('category')

     const uploadImage = (event) => {
        setFiles([event.target.files[0]])
     }

     useEffect(() => {
        axios(baseUrl + path.fetchCategories).then(response => {
            setCategories(response.data.categories)
        })
        axios(baseUrl + path.getInstructors).then(response => {
            setInstructors(response.data.instructors)
        })
     }, [])

     useEffect(() => {
        if(categories){
            setSelectedCategory(categories.find(cat => cat.name == categoryValue?.label))
            setValue('subCategory', null)
        }
     }, [categoryValue, categories])

     const submit = (data) => {
        return new Promise((resolve, reject) => {
            axios(baseUrl + path.addCourse, {
                method: 'post',
                data: {
                    ...data,
                    subcategoryId: data.subCategory.value,
                    instructorId: data.instructor.value,
                    languages: data.languages.value,
                    level: data.level.value,
                    thumbnail: sources
                }
            }).then(response => {
                resolve(true)
                if(response.data.success){
                    setNotification({
                        message: 'Course successfully created!',
                        visible: true,
                        type: 'success'
                    })
                } else {
                    setNotification({
                        message: response.data.message,
                        visible: true,
                        type: 'error'
                    })
                }
            }).catch(e => {
                console.log(e)
                resolve(true)
                setNotification({
                    message: 'Unkown error occured!',
                    visible: true,
                    type: 'error'
                })
            })
        })
     }

    return (
    <div className='flex flex-col gap-5 h-full w-full bg-white rounded-sm p-4'>
        <h2 className='text-black text-[18px] font-bold'>Create Course</h2>
        <div className='flex flex-col gap-3'>
            <form onSubmit={handleSubmit(submit)} className='flex flex-col gap-3 w-fit'>
                <div className='grid grid-cols-2 w-fit gap-x-5 gap-y-5'>
                    <input {...register('title', {required: true})} placeholder='Course Title' type='text' className='border-[1px] border-solid border-[#00000090] text-black placeholder:text-[#434343] p-2 w-full' />
                    {/* {register({ name: 'category' }, {required: true})} */}
                    <Controller
                        name="category"
                        control={control}
                        rules={{ required: true }}
                        render={({ field }) => (
                            <Select
                                {...field}
                                // onChange={(data) => setSelectedCategory(categories.find(cat => cat.name == data.label))}
                                className='text-black placeholder:text-[#434343] w-full'
                                defaultValue={''}
                                placeholder='Course Category'
                                options={categories.map(cat => ({label: cat.name, value: cat.id}))}
                            />
                        )}
                    />
                    
                    {/* {register({ name: 'subcategory' }, {required: true})} */}
                    <Controller
                        name="subCategory"
                        control={control}
                        rules={{ required: true }}
                        render={({ field }) => (
                            <Select
                                {...field}
                                className='text-black placeholder:text-[#434343] w-full'
                                defaultValue={''}
                                placeholder={selectedCategory ? 'Course Sub-Category' : 'Please first select main category'}
                                options={selectedCategory?.subcategories?.map(cat => ({label: cat.name, value: cat.id})) || []}
                            />
                        )}
                    />
                    <Controller
                        name="instructor"
                        control={control}
                        rules={{ required: true }}
                        render={({ field }) => (
                            <Select
                                {...field}
                                className='text-black placeholder:text-[#434343] w-full'
                                defaultValue={''}
                                placeholder='Course Instructor'
                                options={instructors.map(ins => ({label: ins?.user?.firstName + ' ' + ins?.user?.lastName, value: ins.id}))}
                            />
                        )}
                    />
                    {/* {register({ name: 'level' }, {required: true})} */}
                    <Controller
                        name="level"
                        control={control}
                        rules={{ required: true }}
                        render={({ field }) => (
                            <Select
                                {...field}
                                className='text-black placeholder:text-[#434343] w-full'
                                defaultValue={''}
                                placeholder='Course Level'
                                options={levelOptions}
                            />
                        )}
                    />
                    
                    <Controller
                        name="languages"
                        control={control}
                        rules={{ required: true }}
                        render={({ field }) => (
                            <Select
                                {...field}
                                className='text-black placeholder:text-[#434343] w-full'
                                defaultValue={''}
                                placeholder='Language'
                                options={languageOptions}
                            />
                        )}
                    />
                    <input {...register('price', {required: true})} placeholder='Price' type='number' className='h-fit border-[1px] border-solid border-[#00000090] text-black placeholder:text-[#434343] p-2 w-full' />
                    <textarea {...register('description', {required: true})} placeholder='Course Description' cols={3} rows={3} type='text' className='border-[1px] border-solid border-[#00000090] text-black placeholder:text-[#434343] p-2 w-full' />
                    <div className='flex flex-col gap-2'>
                        <p className='text-[14px] text-black'>Thumbnail</p>
                        <div className='flex gap-2 items-center'>
                            <input ref={fileRef} onChange={uploadImage} type='file' className='border-solid border-[1px] border-[#00000040] p-2' />
                            <button onClick={() => fileRef.current?.click()} className={`bg-black p-2 text-[12px] text-white`}>Change</button>
                        </div>
                        <div className='flex flex-wrap gap-2'>
                            {files.map(file => (
                                <UploadItem file={file} setUploading={setUploading} setSources={setSources} />
                            ))}
                        </div>
                    </div>
                    <div></div>
                    <div className='flex w-full gap-3 items-center'>
                        <div className='flex items-center gap-1'>
                            <input {...register('hasCertificate')} type='checkbox' />
                            <p className='text-[12px]'>Has Certificate</p>
                        </div>
                        <div className='flex items-center gap-1'>
                            <input {...register('hasLiveSession')} type='checkbox' />
                            <p className='text-[12px]'>Has Live Session</p>
                        </div>
                        <div className='flex items-center gap-1'>
                            <input {...register('hasInPerson')} type='checkbox' />
                            <p className='text-[12px]'>Has In Person Mettings</p>
                        </div>
                    </div>
                    
                    <button disabled={isSubmitting || !isValid || !sources} type='submit' className={`${(!sources || !isValid) ? 'bg-[#a3a3a3]' : 'bg-main'} text-white text-[14px] w-full p-3 flex items-center justify-center h-fit`}>
                        {isSubmitting ? (
                            <Oval
                                visible={true}
                                height="21"
                                width="21"
                                color="#198754"
                                ariaLabel="oval-loading"
                                wrapperStyle={{}}
                                wrapperClass=""
                                strokeWidth={3}
                            />
                        ) : 'Save'}
                    </button>
                </div>
                
                
            </form>
        </div>
    </div>
    )
}

function UploadItem({ file, setUploading, setSources }){
    const [loading, setLoading] = useState(true)
    const [source, setSource] = useState(null)

    useEffect(() => {
        setLoading(true)
        let form  = new FormData()
        form.append('file', file)
        console.log(file)
        axios(baseUrl + path.uploadFile + '?to=images', {
            data: form,
            method: 'post',
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(response => {
            if(response.data.success){
                setLoading(false)
                setSource(response.data.source)
                setSources(response.data.source)
            }
        })
    }, [file])

    return (
        <div className='w-[50px] h-[50px] border-[#00000050] border-solid border-[1px] p-1 flex items-center justify-center'>
            {loading ? (
                <Oval
                    visible={true}
                    height="24"
                    width="25"
                    color="#198754"
                    ariaLabel="oval-loading"
                    wrapperStyle={{}}
                    wrapperClass=""
                    strokeWidth={3}
                /> ): (
                    <img src={baseUrl + source} alt='source' className='w-full h-full object-contain'  />
                )}
        </div>
    )
}